import { NgModule } from "@angular/core";
import { MapEntriesPipe } from "./mapEntries.pipe";
import { AgeFormatPipe } from "./ageFormat.pipe";
import { FromWeiPipe } from "./fromWei.pipe";
import { WalletShortPipe } from "./wallet-short.pipe";
import { ReplacePipe } from "./replace-string.pipe";
import { ImgFromChainPipe } from "./img-from-chain.pipe";

@NgModule({
    declarations: [
        MapEntriesPipe,
        AgeFormatPipe,
        FromWeiPipe,
        WalletShortPipe,
        ReplacePipe,
        ImgFromChainPipe
    ],
    imports: [],
    exports: [
        MapEntriesPipe,
        AgeFormatPipe,
        FromWeiPipe,
        WalletShortPipe,
        ReplacePipe,
        ImgFromChainPipe
    ]
})
export class PipesModule { }